import React from 'react'

const FooterSectionTwo = () => {
    return (
        <>
            <h3 className="footer-title">Find It Fast</h3>
            <ul className="footer-menu-list">
                <li>
                    <a href="#">Laptop $ Computers</a>
                </li>
                <li>
                    <a href="#">Smart Phone &amp; Tablets</a>
                </li>
                <li>
                    <a href="#">TV &amp; Audio</a>
                </li>
                <li>
                    <a href="#">Cameras &amp; Photography</a>
                </li>
                <li>
                    <a href="#">Gadgets</a>
                </li>
                <li>
                    <a href="#">Car Electronic &amp; GP5</a>
                </li>
                <li>
                    <a href="#">Accesories</a>
                </li>
            </ul>
        </>
    )
}

export default FooterSectionTwo